export default __webpack_public_path__ + "static/media/cancha_1 Banco Guayaquil.bbd0e99e.jpg";